document.addEventListener('alpine:init', function () {
    Alpine.data('mediaGallery', function () {
        var glide;
        return {
            activeSlide: 0,
            init: function () {
                this.initialiseCarousel();
            },
            initialiseCarousel: function () {
                var _this = this;
                glide = new window.Glide(this.$refs.carousel, {
                    type: 'carousel',
                    gap: 10,
                    perView: 1,
                }).mount();
                glide.on('move', function () {
                    var videoSlides = _this.$refs.slides.querySelectorAll('li[data-slide-type="video"]');
                    // Reset the source of all iframes to prevent them from playing.
                    videoSlides.length &&
                        videoSlides.forEach(function (slide) {
                            var iframe = slide.querySelector('iframe');
                            if (iframe) {
                                iframe.src = iframe.src;
                            }
                        });
                });
                // Refresh lazy-load script whenever we switch slides.
                glide.on('move.after', function () {
                    _this.activeSlide = glide.index;
                    // Set slides that are not active to be 'inert'.
                    var slides = Array.from(_this.$refs.carousel.querySelectorAll('.glide__slide'));
                    slides.forEach(function (slide) {
                        var isActive = slide.classList.contains('glide__slide--active');
                        if (isActive) {
                            slide.removeAttribute('inert');
                        }
                        else {
                            slide.setAttribute('inert', '');
                        }
                    });
                    _this.scrollToActiveThumb();
                });
            },
            slideTo: function (index) {
                glide.go("=".concat(index));
            },
            scrollToActiveThumb: function () {
                var currentSlide = this.$refs.thumbs.children[this.activeSlide];
                if (!currentSlide)
                    return;
                var center = this.$refs.thumbs.getBoundingClientRect().width / 2;
                this.$store.app.scrollHorizontally(this.$refs.thumbs, currentSlide, center);
            },
        };
    });
});
